"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _IndexProvider = require("./IndexProvider");
var _styles = require("../styles");
var _TableContext = _interopRequireDefault(require("./TableContext"));
var _TableRowContext = _interopRequireDefault(require("./TableRowContext"));
var _classes = require("./classes");
var _material = require("@mui/material");
var _TableCell = _interopRequireDefault(require("@mui/material/TableCell"));
var _clsx2 = _interopRequireDefault(require("clsx"));
var _propTypes = _interopRequireDefault(require("prop-types"));
var _react = require("react");
var _jsxRuntime = require("react/jsx-runtime");
var _excluded = ["className", "borderRight", "borderLeft", "classes", "padding", "background", "columnTitle", "disableGutters"],
  _excluded2 = ["paddingInput", "paddingActions", "disableGutters"];
function _interopRequireDefault(e) { return e && e.__esModule ? e : { "default": e }; }
function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
function _slicedToArray(r, e) { return _arrayWithHoles(r) || _iterableToArrayLimit(r, e) || _unsupportedIterableToArray(r, e) || _nonIterableRest(); }
function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _unsupportedIterableToArray(r, a) { if (r) { if ("string" == typeof r) return _arrayLikeToArray(r, a); var t = {}.toString.call(r).slice(8, -1); return "Object" === t && r.constructor && (t = r.constructor.name), "Map" === t || "Set" === t ? Array.from(r) : "Arguments" === t || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(t) ? _arrayLikeToArray(r, a) : void 0; } }
function _arrayLikeToArray(r, a) { (null == a || a > r.length) && (a = r.length); for (var e = 0, n = Array(a); e < a; e++) n[e] = r[e]; return n; }
function _iterableToArrayLimit(r, l) { var t = null == r ? null : "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"]; if (null != t) { var e, n, i, u, a = [], f = !0, o = !1; try { if (i = (t = t.call(r)).next, 0 === l) { if (Object(t) !== t) return; f = !1; } else for (; !(f = (e = i.call(t)).done) && (a.push(e.value), a.length !== l); f = !0); } catch (r) { o = !0, n = r; } finally { try { if (!f && null != t["return"] && (u = t["return"](), Object(u) !== u)) return; } finally { if (o) throw n; } } return a; } }
function _arrayWithHoles(r) { if (Array.isArray(r)) return r; }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == _typeof(i) ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != _typeof(t) || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != _typeof(i)) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
var useBorderStyles = (0, _styles.makeStyles)(function (theme) {
  var baseBorder = {
    content: "''",
    display: 'block',
    background: (0, _styles.blend)(theme.palette.background.paper, theme.palette.action.active, theme.palette.action.activatedOpacity),
    position: 'absolute'
  };
  var horizontal = {
    top: 0,
    bottom: 0,
    width: '1px'
  };
  var vertical = {
    right: 0,
    left: 0,
    height: '1px'
  };
  return {
    borderLeft: {
      '&:after': _objectSpread(_objectSpread(_objectSpread({}, baseBorder), horizontal), {}, {
        left: 1
      })
    },
    borderRight: {
      '&:after': _objectSpread(_objectSpread(_objectSpread({}, baseBorder), horizontal), {}, {
        right: 1
      })
    },
    borderTop: {
      '&:before': _objectSpread(_objectSpread(_objectSpread({}, baseBorder), vertical), {}, {
        top: -1
      })
    },
    borderBottom: {
      '&:before': _objectSpread(_objectSpread(_objectSpread({}, baseBorder), vertical), {}, {
        bottom: -1
      })
    }
  };
}, {
  name: 'GgTableCellBorder'
});
var styles = function styles(theme) {
  return {
    root: {
      padding: '16px 8px',
      backgroundColor: 'inherit',
      fontSize: theme.typography.pxToRem(13),
      position: 'relative',
      '&:first-child': {
        paddingLeft: 16
      },
      '&:last-child': {
        paddingRight: 16
      }
    },
    paddingActions: {
      paddingTop: 0,
      paddingBottom: 0,
      '&:last-child': {
        paddingTop: 0,
        paddingBottom: 0
      }
    },
    disableGutters: {
      paddingTop: 8,
      paddingBottom: 8,
      '&:first-child': {
        paddingLeft: 0
      },
      '&:last-child': {
        paddingRight: 0
      }
    },
    sizeSmall: {
      paddingTop: 8,
      paddingBottom: 8,
      '&:first-child': {
        paddingLeft: 16
      },
      '&:last-child': {
        paddingRight: 16
      }
    },
    body: {
      color: theme.palette.text.primary,
      lineHeight: theme.typography.pxToRem(15)
    },
    footer: {
      color: theme.palette.text.primary,
      lineHeight: theme.typography.pxToRem(15),
      fontWeight: theme.typography.fontWeightBold
    },
    head: {
      color: theme.palette.text.secondary,
      lineHeight: theme.typography.pxToRem(15),
      fontWeight: 'normal',
      fontSize: theme.typography.pxToRem(12)
    }
  };
};
var _i = 0;
var TableCell = /*#__PURE__*/(0, _react.forwardRef)(function (_ref, ref) {
  var className = _ref.className,
    borderRight = _ref.borderRight,
    borderLeft = _ref.borderLeft,
    ggTableCellClasses = _ref.classes,
    paddingProp = _ref.padding,
    background = _ref.background,
    columnTitle = _ref.columnTitle,
    disableGutters = _ref.disableGutters,
    props = _objectWithoutProperties(_ref, _excluded);
  var _useState = (0, _react.useState)(function () {
      return "table-cell-".concat(_i++);
    }),
    _useState2 = _slicedToArray(_useState, 1),
    id = _useState2[0];
  var _useContext = (0, _react.useContext)(_TableContext["default"]),
    setCellCount = _useContext.setCellCount,
    registerColumnTitle = _useContext.registerColumnTitle,
    getColumnTitle = _useContext.getColumnTitle;
  var index = (0, _IndexProvider.useRegisterIndex)(id);
  var cellRef = (0, _react.useRef)(null);
  var handleRef = (0, _material.useForkRef)(ref, cellRef);
  var _useContext2 = (0, _react.useContext)(_TableRowContext["default"]),
    borderTop = _useContext2.borderTop,
    borderBottom = _useContext2.borderBottom;
  var paddingInputClassName = ggTableCellClasses.paddingInput,
    paddingActionsClassName = ggTableCellClasses.paddingActions,
    disableGuttersClassName = ggTableCellClasses.disableGutters,
    classes = _objectWithoutProperties(ggTableCellClasses, _excluded2);
  var borderClasses = useBorderStyles();
  (0, _react.useEffect)(function () {
    setCellCount(function (c) {
      return c + 1;
    });
    return function () {
      return setCellCount(function (c) {
        return c - 1;
      });
    };
  }, []);
  var padding = paddingProp === 'input' ? undefined : paddingProp;
  var getDataCy = function getDataCy() {
    return {
      'data-cy': 'TableCell',
      'data-cy-index': index,
      'data-cy-column-title': getColumnTitle(index)
    };
  };
  (0, _react.useEffect)(function () {
    if (columnTitle) {
      registerColumnTitle(index, columnTitle);
    }
  }, [columnTitle, index]);
  return /*#__PURE__*/(0, _jsxRuntime.jsx)(_TableCell["default"], _objectSpread(_objectSpread({}, props), {}, {
    ref: handleRef,
    padding: padding,
    classes: classes,
    className: (0, _clsx2["default"])(className, _classes.STICKY_TABLE_CELL, _defineProperty(_defineProperty(_defineProperty(_defineProperty(_defineProperty(_defineProperty(_defineProperty({}, borderClasses.borderRight, borderRight), borderClasses.borderLeft, borderLeft), borderClasses.borderTop, borderTop), borderClasses.borderBottom, borderBottom), paddingInputClassName, paddingProp === 'input'), paddingActionsClassName, paddingProp === 'actions'), disableGuttersClassName, disableGutters))
  }, getDataCy()));
});
TableCell.propTypes = {
  /**
   * Set the text-align on the table cell content.
   * Monetary or generally number fields should be right aligned
   * as that allows you to add them up quickly in your head
   * without having to worry about decimals.
   */
  align: _propTypes["default"].oneOf(['center', 'inherit', 'justify', 'left', 'right']),
  /**
   * The table cell contents.
   */
  children: _propTypes["default"].oneOfType([_propTypes["default"].string, _propTypes["default"].node, _propTypes["default"].func]),
  /**
   *	Override or extend the styles applied to the component.
   */
  classes: _propTypes["default"].object,
  className: _propTypes["default"].string,
  /**
   * 	The component used for the root node. Either a string to use a HTML element or a component.
   */
  component: _propTypes["default"].elementType,
  /**
   * Sets the padding applied to the cell.
   * By default, the Table parent component set the value (normal).
   * default is deprecated, use normal instead.
   */
  padding: _propTypes["default"].oneOf(['normal', 'checkbox', 'none', 'default']),
  /**
   * Set scope attribute.
   */
  scope: _propTypes["default"].string,
  /**
   * Specify the size of the cell. By default, the Table parent component set the value (medium).
   */
  size: _propTypes["default"].oneOf(['small', 'medium']),
  /**
   * Set data-cy-sort direction.
   */
  sortDirection: _propTypes["default"].oneOf(['asc', 'desc', false]),
  /**
   * Specify the cell type. By default, the TableHead, TableBody or TableFooter
   * parent component set the value.
   */
  variant: _propTypes["default"].oneOf(['body', 'footer', 'head']),
  borderRight: _propTypes["default"].bool,
  borderLeft: _propTypes["default"].bool
};
var _default = exports["default"] = (0, _styles.withStyles)(styles, {
  name: 'GgTableCell'
})(TableCell);